export const XStealIntrigueSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 100) * 123}
      viewBox="0 0 100 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_286_19)">
        <mask id="path-1-inside-1_286_19" fill="white">
          <rect
            x="1"
            y="67.707"
            width="37"
            height="56"
            rx="1"
            transform="rotate(-14.068 1 67.707)"
          />
        </mask>
        <rect
          x="1"
          y="67.707"
          width="37"
          height="56"
          rx="1"
          transform="rotate(-14.068 1 67.707)"
          fill="black"
        />
        <rect
          x="1"
          y="67.707"
          width="37"
          height="56"
          rx="1"
          transform="rotate(-14.068 1 67.707)"
          stroke="white"
          strokeOpacity="0.92"
          strokeWidth="4"
          mask="url(#path-1-inside-1_286_19)"
        />
      </g>
      <g filter="url(#filter1_di_286_19)">
        <mask id="path-2-inside-2_286_19" fill="white">
          <rect
            x="21.2927"
            y="60.6348"
            width="37"
            height="56"
            rx="1"
            transform="rotate(-6.98601 21.2927 60.6348)"
          />
        </mask>
        <rect
          x="21.2927"
          y="60.6348"
          width="37"
          height="56"
          rx="1"
          transform="rotate(-6.98601 21.2927 60.6348)"
          fill="black"
        />
        <rect
          x="21.2927"
          y="60.6348"
          width="37"
          height="56"
          rx="1"
          transform="rotate(-6.98601 21.2927 60.6348)"
          stroke="white"
          strokeOpacity="0.92"
          strokeWidth="4"
          mask="url(#path-2-inside-2_286_19)"
        />
      </g>
      <g filter="url(#filter2_di_286_19)">
        <mask id="path-3-inside-3_286_19" fill="white">
          <rect
            x="44.2013"
            y="58.0764"
            width="37"
            height="56"
            rx="1"
            transform="rotate(2.86762 44.2013 58.0764)"
          />
        </mask>
        <rect
          x="44.2013"
          y="58.0764"
          width="37"
          height="56"
          rx="1"
          transform="rotate(2.86762 44.2013 58.0764)"
          fill="black"
        />
        <rect
          x="44.2013"
          y="58.0764"
          width="37"
          height="56"
          rx="1"
          transform="rotate(2.86762 44.2013 58.0764)"
          stroke="white"
          strokeOpacity="0.92"
          strokeWidth="4"
          mask="url(#path-3-inside-3_286_19)"
        />
      </g>
      <g filter="url(#filter3_di_286_19)">
        <rect
          x="61.5657"
          y="58.386"
          width="38"
          height="57"
          rx="1"
          transform="rotate(10.1916 61.5657 58.386)"
          fill="url(#paint0_linear_286_19)"
        />
        <rect
          x="61.9693"
          y="58.9665"
          width="37"
          height="56"
          rx="0.5"
          transform="rotate(10.1916 61.9693 58.9665)"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <g filter="url(#filter4_i_286_19)">
        <path
          d="M70.6648 80.9351L75.3534 67.2995L72.9941 84.5713C70.8809 85.2638 65.6801 87.9216 65.2318 90.415C64.6715 93.5317 70.458 95.9126 72.9201 97.4277C65.2734 96.3661 58.6011 96.1567 61.1776 88.0774C63.5837 84.6491 68.5049 81.8874 70.6648 80.9351Z"
          fill="#F1D891"
        />
        <path
          d="M90.1696 84.4416C89.2851 81.0651 80.2821 79.9828 76.7242 80.4157C78.8987 82.1472 85.2529 82.7533 85.555 85.2207C85.8572 87.6881 79.439 92.9691 77.2324 94.1812L75.0132 110.674L80.7044 95.6097C84.0068 92.4497 91.6094 89.938 90.1696 84.4416Z"
          fill="#F1D891"
        />
        <ellipse
          cx="75.1833"
          cy="88.9866"
          rx="3.6699"
          ry="3.95833"
          transform="rotate(10.1916 75.1833 88.9866)"
          fill="#F1D891"
        />
      </g>
      <path
        d="M20.9746 22.1918L33.5811 7.39296L33.5813 7.39295C43.4472 7.1189 63.1788 6.5708 65.3712 8.76322C67.5636 10.9557 68.8882 26.5767 69.208 28.4951C69.5277 30.4134 65.3712 46.3085 62.9047 48.2269C60.9699 49.7318 58.2458 48.5923 57.9718 48.2269C57.6977 49.2317 56.0534 50.9674 52.7648 50.9674C49.4761 50.9674 40.7096 34.1613 39.0621 32.8799C36.5956 30.9615 34.1292 32.0577 28.1 28.4951C26.0671 27.2938 21.8881 23.9275 20.9746 22.1918Z"
        fill="black"
      />
      <path
        d="M57.7151 29.5977L55.5227 40.8339C52.0514 35.4442 43.9211 25.761 48.9454 22.7464C52.5081 20.6088 56.2535 26.3091 57.7151 29.5977Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M37.7093 34.8047C39.7571 36.2383 42.3682 41.5647 43.1903 44.3966C41.9114 44.3966 39.5728 44.4514 38.2574 43.5744C36.9419 42.6975 36.2477 40.8339 36.339 40.2858C35.6082 40.4685 33.7081 40.4502 31.9542 38.9155C30.2002 37.3808 30.6752 33.8912 31.406 32.6123C32.3196 32.8864 34.9687 32.8864 37.7093 34.8047Z"
        fill="black"
      />
      <rect
        x="0.232875"
        y="2.81882"
        width="15.477"
        height="7.51023"
        transform="matrix(-0.646487 0.762925 0.762925 0.646487 23.0499 0.818824)"
        fill="white"
        stroke="black"
        strokeWidth="4"
      />
      <defs>
        <filter
          id="filter0_di_286_19"
          x="0.212845"
          y="57.9261"
          width="51.0767"
          height="64.8885"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_286_19"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_286_19"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_286_19"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_286_19"
          />
        </filter>
        <filter
          id="filter1_di_286_19"
          x="20.4068"
          y="55.2487"
          width="45.3082"
          height="61.8562"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_286_19"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_286_19"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_286_19"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_286_19"
          />
        </filter>
        <filter
          id="filter2_di_286_19"
          x="40.4485"
          y="57.1251"
          width="41.6578"
          height="59.6834"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_286_19"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_286_19"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_286_19"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_286_19"
          />
        </filter>
        <filter
          id="filter3_di_286_19"
          x="50.6411"
          y="57.547"
          width="49.164"
          height="64.5024"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_286_19"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_286_19"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_286_19"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_286_19"
          />
        </filter>
        <filter
          id="filter4_i_286_19"
          x="60.6145"
          y="67.2995"
          width="29.7345"
          height="43.3742"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.258333 0 0 0 0 0.197506 0 0 0 0 0.024757 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_286_19"
          />
        </filter>
        <linearGradient
          id="paint0_linear_286_19"
          x1="80.5657"
          y1="58.386"
          x2="80.5657"
          y2="115.386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716238" />
          <stop offset="0.109375" stopColor="#4F3E11" />
          <stop offset="0.489583" stopColor="#352703" />
          <stop offset="0.911458" stopColor="#4F3E11" />
          <stop offset="1" stopColor="#716238" />
        </linearGradient>
      </defs>
    </svg>
  );
};
